import { useEffect, useState } from 'react';
import { recruitingApi } from '../../../api/recruiting.js';

export default function Candidates() {
  const [items, setItems] = useState([]);
  const [requisitions, setRequisitions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [showApp, setShowApp] = useState(false);
  const [error, setError] = useState(null);
  const [notice, setNotice] = useState(null);

  function refresh() {
    setLoading(true);
    recruitingApi
      .listCandidates()
      .then((d) => setItems(d?.items || []))
      .catch((e) => setError(e.response?.data?.message || 'Failed to load'))
      .finally(() => setLoading(false));
  }
  useEffect(() => {
    refresh();
    recruitingApi.listRequisitions().then((d) => setRequisitions(d?.items || [])).catch(() => {});
  }, []);

  async function createCandidate(e) {
    e.preventDefault();
    const form = e.currentTarget;
    const fd = new FormData(form);
    try {
      await recruitingApi.createCandidate({
        name: fd.get('name'),
        email: fd.get('email'),
        phone: fd.get('phone') || null,
        source: fd.get('source') || null,
      });
      form.reset();
      setShowForm(false);
      refresh();
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to create candidate');
    }
  }

  async function createApplication(e) {
    e.preventDefault();
    const fd = new FormData(e.currentTarget);
    try {
      const d = await recruitingApi.createApplication({
        candidateId: fd.get('candidateId'),
        requisitionId: fd.get('requisitionId'),
      });
      setShowApp(false);
      setNotice(`Application created (${d?.application?.id})`);
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to create application');
    }
  }

  return (
    <section data-testid="recruiting-candidates-page" data-loading={loading ? 'true' : 'false'}>
      <header className="page-header">
        <div>
          <h1>Candidates</h1>
          <p className="muted">{items.length} candidates</p>
        </div>
        <div className="actions">
          <button className="btn" data-testid="recruiting-application-create" onClick={() => setShowApp((s) => !s)}>
            {showApp ? 'Close' : '+ New Application'}
          </button>
          <button className="btn primary" data-testid="recruiting-candidate-create" onClick={() => setShowForm((s) => !s)}>
            {showForm ? 'Close' : '+ New Candidate'}
          </button>
        </div>
      </header>

      {error && <div className="alert error">{error}</div>}
      {notice && <div className="alert" data-testid="recruiting-application-notice">{notice}</div>}

      {showForm && (
        <form onSubmit={createCandidate} className="card form-card grid-form">
          <label>Name<input name="name" data-testid="recruiting-candidate-name-input" required /></label>
          <label>Email<input name="email" type="email" data-testid="recruiting-candidate-email-input" required /></label>
          <label>Phone<input name="phone" /></label>
          <label>Source<input name="source" placeholder="LinkedIn, referral…" /></label>
          <div className="full actions"><button className="btn primary" type="submit" data-testid="recruiting-candidate-submit">Create</button></div>
        </form>
      )}

      {showApp && (
        <form onSubmit={createApplication} className="card form-card grid-form">
          <label>Candidate
            <select name="candidateId" data-testid="recruiting-application-candidate-select" required>
              <option value="">—</option>
              {items.map((c) => <option key={c.id} value={c.id}>{c.name} ({c.email})</option>)}
            </select>
          </label>
          <label>Requisition
            <select name="requisitionId" data-testid="recruiting-application-requisition-select" required>
              <option value="">—</option>
              {requisitions.map((r) => <option key={r.id} value={r.id}>{r.title}</option>)}
            </select>
          </label>
          <div className="full actions"><button className="btn primary" type="submit" data-testid="recruiting-application-submit">Create application</button></div>
        </form>
      )}

      <div className="card">
        <table className="data-table" data-testid="recruiting-candidate-list">
          <thead><tr><th>Name</th><th>Email</th><th>Source</th><th>Status</th></tr></thead>
          <tbody>
            {items.map((c) => (
              <tr key={c.id} data-testid={`recruiting-candidate-row-${c.id}`}>
                <td><strong>{c.name}</strong></td>
                <td>{c.email}</td>
                <td className="muted">{c.source || '—'}</td>
                <td><span className={`chip status-${c.status}`}>{c.status}</span></td>
              </tr>
            ))}
            {!loading && items.length === 0 && <tr><td colSpan={4} className="muted">No candidates yet.</td></tr>}
          </tbody>
        </table>
      </div>
    </section>
  );
}
